import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const OptionsMeatball = (props: Props): ReactElement => {
  const { width, height, style } = props;
  return (
    <svg width={width} height={height} style={style} viewBox="0 0 24 24">
      <path d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z" />
    </svg>
  );
};

OptionsMeatball.defaultProps = {
  width: '100%',
  height: '100%',
};

export default OptionsMeatball;
